__turbopack_context__.v({
  "bento-content": "x0-vVq_bento-content",
  "bg-grad-blue": "x0-vVq_bg-grad-blue",
  "caption": "x0-vVq_caption",
  "cardElement": "x0-vVq_cardElement",
  "description": "x0-vVq_description",
  "fadeInUp": "x0-vVq_fadeInUp",
  "fadeOutDown": "x0-vVq_fadeOutDown",
  "full-width": "x0-vVq_full-width",
  "lg": "x0-vVq_lg",
  "overlay": "x0-vVq_overlay",
  "root": "x0-vVq_root" + " " + __turbopack_context__.i(905307)["sectionPadding"],
  "uhx-text-content": "x0-vVq_uhx-text-content",
  "w-full": "x0-vVq_w-full",
  "xl": "x0-vVq_xl",
});
